import React from 'react';
import { connect } from 'react-redux';
import { parse } from 'qs';

// Components
import { Layout, Col, Row } from 'antd';
import Navbar from './Menu';
import Footer from './Footer';

// Selectors
import { getUserName, getIsAuthenticated } from '../../data/auth/selectors';
import { getInvitationAcceptedState, selectedLangageSelector } from '../../data/app/selector';

// Others
import { strings } from '../../localization';

const ApplicationView = ({
    children,
    protectedRoutes,
    isAuthenticated,
    invitationAccepted,
    loggedUserName,
    logout
}) => {
        
    const path = parse(window.location.search, { ignoreQueryPrefix: true });

    const hasAuthToken = path.authToken !== undefined && path.authToken !== null;

    console.log("innerWidth: ", window.innerWidth);

    const paddingWidth = window.innerWidth >= 1000 ? 24 : 5;

    return <Layout style={{ minHeight: '100vh', overflow: 'hidden' }}>
        {!hasAuthToken && isAuthenticated && invitationAccepted !== false && (
            <Navbar
                msgs={strings}
                logout={logout}
                loggedUserName={loggedUserName}
                protectedRoutes={protectedRoutes}
            />
        )}
        <Layout.Content>
            <Row style={{ padding: paddingWidth, minHeight: 280 }}>
                <Col xs={24} lg={{ span: 24 }}>
                    {children}
                </Col>
            </Row>
        </Layout.Content>
        <Layout.Footer style={{ textAlign: 'center' }}>
            <Footer />
        </Layout.Footer>
    </Layout>
};

export default connect(state => ({
    selectedLocale: selectedLangageSelector(state),
    loggedUserName: getUserName(state),
    isAuthenticated: getIsAuthenticated(state),
    invitationAccepted: getInvitationAcceptedState(state)
}))(ApplicationView);
